export const copilotSettingsDiagDataCollectorDescription = "B07BHb";
export default {copilotSettingsDiagDataCollectorDescription};